const { default: ProductTile } = require("./ProductTile");

export { default } from './ProductTile';